// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"ab799d56","239":"9c69bb42","389":"37ae89c8","732":"27abbe2f","857":"486a22f0","977":"e4269193"}[chunkId] + ".chunk.js";
};